import { MinMaxValue } from "../../../../../../types/filters";

/**
 * TODO: Refactor/Delete this
 * A similar logic is happening with New Product Detections by Segment for Key Players
 */
export const EMPLOYEES_RANGE: MinMaxValue[] = [
  { min: 10_000, max: null },
  { min: 5000, max: 9999 },
  { min: 1000, max: 4999 },
  { min: 500, max: 999 },
  { min: 200, max: 499 },
  { min: 50, max: 199 },
  { min: 1, max: 49 },
];

/**
 * TODO: Refactor/Delete this
 * A similar logic is happening with New Product Detections by Segment for Key Players
 */
export const REVENUE_RANGE: MinMaxValue[] = [
  { min: 1, max: 9_999_999 },
  { min: 10_000_000, max: 24_999_999 },
  { min: 25_000_000, max: 49_999_999 },
  { min: 50_000_000, max: 249_999_999 },
  { min: 250_000_000, max: 499_999_999 },
  { min: 500_000_000, max: 999_999_999 },
  { min: 1_000_000_000, max: 4_999_999_999 },
  { min: 5_000_000_000 },
];

export const DEFAULT_ORDER_BY = "COUNT";
export const DEFAULT_GROUP_BY = "PRODUCT";
